import { createWebHistory, createRouter } from "vue-router";
import BoardHome from "../components/BoardHome.vue";
import UserLogin from "../components/UserLogin.vue";
// lazy-loaded
// const BoardMain = () => import("../components/BoardMain.vue")
const StoreCardsList = () => import("../components/StoreCardsList.vue")
const FirmsList = () => import("../components/FirmsList.vue")
const ReceivedOrdersList = () => import("../components/ReceivedOrdersList.vue")
const ReceivedOrder = () => import("../components/ReceivedOrder.vue")
const IssuedOrdersList = () => import("../components/IssuedOrdersList.vue")
const IssuedOrder = () => import("../components/IssuedOrder.vue")

const routes = [
  {
    path: "/",
    name: "board-home",
    component: BoardHome,
  },
  {
    path: "/board-home",
    component: BoardHome,
  },
  {
    path: "/user-login",
    component: UserLogin,
  },
  {
    path: "/firms-list",
    name: "FirmsList",
    // lazy-loaded
    component: FirmsList,
  },
  {
    path: "/storecards-list",
    name: "StoreCardsList",
    // lazy-loaded
    component: StoreCardsList,
  },
  {
    path: "/receivedorders-list",
    name: "ReceivedOrdersList",
    // lazy-loaded
    component: ReceivedOrdersList,
  },
  {
    path: "/receivedorder-detail",
    name: "ReceivedOrder",
    // lazy-loaded
    component: ReceivedOrder,
  },
  {
    path: "/issuedorder-list",
    name: "IssuedOrdersList",
    // lazy-loaded
    component: IssuedOrdersList,
  },
  {
    path: "/issuedorder-detail",
    name: "IssuedOrder",
    // lazy-loaded
    component: IssuedOrder,
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// router.beforeEach((to, from, next) => {
//   const publicPages = ['/login', '/register', '/home'];
//   const authRequired = !publicPages.includes(to.path);
//   const loggedIn = localStorage.getItem('user');

//   // trying to access a restricted page + not logged in
//   // redirect to login page
//   if (authRequired && !loggedIn) {
//     next('/login');
//   } else {
//     next();
//   }
// });

export default router;
